import { render, staticRenderFns } from "./class-and-class-program.vue?vue&type=template&id=4c5e3b18"
var script = {}
import style0 from "./class-and-class-program.vue?vue&type=style&index=0&id=4c5e3b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports